import * as React from 'react';
import { IconClose16 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IDealFeaturesModalHeaderProps {
  onClose: () => void;
}

export const VideoPlaybackModalHeader: React.FC<React.PropsWithChildren<IDealFeaturesModalHeaderProps>> = ({
  onClose,
}) => {
  return (
    <header className={styles['container']}>
      <button className={styles['button']} type="button" aria-label="Закрыть" onClick={onClose}>
        <IconClose16 />
      </button>
    </header>
  );
};
